import { sortBy } from 'lodash'
import { employeeNameSort, formatMfaStatusType, getAutheticationTypeFormatter } from './table.util'

const getMfaConfiguration = (item, intl) => {
  const configurationStatus = item?.mfaConfigurations?.configurationStatus
  const numberCaPolicies = item?.mfaConfigurations?.affectedByCAs?.length

  const configurationStatusMessage = configurationStatus
    ? intl.formatMessage({ id: `INTEGRATION.${configurationStatus}` })
    : ''
  const isAffectedByCAs = ['CAP', 'DUO', 'DUO_AND_CAP'].includes(configurationStatus)
  const numberCaPoliciesMessage = `${numberCaPolicies} ${intl.formatMessage({
    id: 'INTEGRATION.CONDITIONALPOLICY',
  })}`

  return `${configurationStatusMessage} ${isAffectedByCAs ? '/' : ''} ${
    isAffectedByCAs ? numberCaPoliciesMessage : ''
  }`.trim()
}

const getMfaStatus = (item, intl) => {
  const mfaStatus = item?.mfaStatus?.status
  const mfaStatusMessage = mfaStatus ? intl.formatMessage({ id: `INTEGRATION.${mfaStatus}` }) : ''

  const statusList = item.mfaStatus?.statusList ?? []
  const statusListMessage = statusList
    .map((obj) =>
      `${formatMfaStatusType(obj.type, intl)} ${obj.status ? '-' : ''} ${
        obj.status ? intl.formatMessage({ id: `GENERAL.${obj.status}` }) : ''
      }`.trim(),
    )
    .join(', ')

  return `${mfaStatusMessage} ${statusListMessage ? '/' : ''} ${statusListMessage}`.trim()
}

const formatMfaReportData = ({ employees }, { order }, intl) =>
  employees
    .sort((a, b) => employeeNameSort(a, b, order, undefined, a, b))
    .map(({ email, licenseType, role, ...item }) => ({
      name: item.displayName || `${item.firstName} ${item.lastName}`,
      email,
      licenseType,
      role,
      mfaConfiguration: getMfaConfiguration(item, intl),
      mfaStatus: getMfaStatus(item, intl),
      authenticationType: item.authenticationType?.map(getAutheticationTypeFormatter(intl)).join(', '),
    }))

const formatLicenseReportData = ({ users }, { order }) => {
  const sortedUsers = order ? sortBy(users, 'name') : users

  if (order === 'desc') {
    sortedUsers.reverse()
  }

  return sortedUsers.map(({ email, roles, licenses, change, status, name }) => ({
    employee: name,
    email,
    role: roles.join(','),
    licenses: licenses.join(','),
    change: change.join(','),
    status,
  }))
}

export default {
  MFA_REPORT: formatMfaReportData,
  LICENSE_REPORT: formatLicenseReportData,
}
